var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"14","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M0 2.276L1.65.625l5.352 5.448L12.35.625 14 2.275l-6.998 7.1L0 2.275z","fill":"#974900"}})])}
var staticRenderFns = []

export { render, staticRenderFns }